var _mask, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabIconChatsNormal = function SvgTabIconChatsNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tab_icon_chats_normal_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21.94c6.627 0 12-4.912 12-10.97S18.626 0 12 0C5.372 0 0 4.911 0 10.97c0 3.948 2.282 7.41 5.706 9.341l-.134 2.517c-.047.884.866 1.487 1.513.998l2.735-2.067q1.062.178 2.18.18",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#847379",
    d: "m5.706 20.312 1.998.106.066-1.239-1.08-.61zm-.134 2.516-1.997-.106zm1.513.998L5.88 22.23zm2.735-2.067.33-1.973-.849-.142-.687.52zM22 10.969c0 4.79-4.305 8.97-10 8.97v4c7.559 0 14-5.641 14-12.97zM12 2c5.695 0 10 4.181 10 8.97h4C26 3.642 19.558-2 12-2zM2 10.97C2 6.18 6.304 2 12 2v-4C4.44-2-2 3.642-2 10.97zm4.69 7.6C3.812 16.947 2 14.108 2 10.97h-4c0 4.758 2.752 8.842 6.724 11.083zm.88 4.364.134-2.516-3.995-.213-.134 2.517zm-1.69-.704c.192-.145.444-.232.707-.23.247.003.446.082.583.172.27.178.415.472.4.762l-3.995-.212a3.14 3.14 0 0 0 1.392 2.79c.896.59 2.222.743 3.324-.09zm2.734-2.067L5.879 22.23l2.412 3.192 2.735-2.068zM12 19.94q-.951 0-1.85-.153l-.66 3.945a15 15 0 0 0 2.51.208z",
    mask: "url(#tab_icon_chats_normal_svg__a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 1.5,
    fill: "#847379"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 1.5,
    fill: "#847379"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 1.5,
    fill: "#847379"
  })));
};
export default SvgTabIconChatsNormal;